import { shareAttachmentActionCreators } from '@app/components/ShareAttachmentModal/modules/shareAttachment'
import { connect } from 'react-redux'
import { AttachmentsListItem } from '../components/AttachmentsListItem'

export default connect(
  undefined,
  shareAttachmentActionCreators,
)(AttachmentsListItem)
